import { useMemo } from 'react'
import logo from '../assets/radici-logo.svg'
import ThemeSwitchIcon from './ThemeSwitchIcon'
import LanguageToggle from './LanguageToggle'
import { useI18n } from '../i18n'

type LandingProps = {
  onLogin: () => void
}

export default function Landing({ onLogin }: LandingProps) {
  const { t } = useI18n()
  const currentYear = useMemo(() => new Date().getFullYear(), [])
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-950">
      <header className="flex items-center justify-between px-4 py-6 max-w-5xl mx-auto w-full">
        <div className="flex items-center gap-3">
          <img src={logo} alt="Radici" className="h-9 md:h-12" />
          <div className="text-sm text-slate-500 dark:text-slate-400 hidden sm:block">
            {t('landing.subtitle')}
          </div>
        </div>
        <div className="flex items-center gap-3">
          <LanguageToggle />
          <ThemeSwitchIcon />
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="w-full max-w-md">
          <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl shadow-lg p-8 space-y-6">
            <div>
              <h1 className="text-2xl font-semibold text-slate-900 dark:text-white mb-1">{t('landing.title')}</h1>
              <p className="text-sm text-slate-600 dark:text-slate-300">{t('landing.body')}</p>
            </div>

            <div className="space-y-3 text-sm text-slate-600 dark:text-slate-300">
              <Feature text={t('landing.feature.monitor')} />
              <Feature text={t('landing.feature.restore')} />
              <Feature text={t('landing.feature.audit')} />
            </div>

            <button className="btn w-full" onClick={onLogin}>
              {t('buttons.login')}
            </button>

            <p className="text-xs text-slate-500 dark:text-slate-400 text-center">
              {t('landing.notice')}
            </p>
          </div>
        </div>
      </main>

      <footer className="py-6 text-center text-xs text-slate-500 dark:text-slate-400">
        © {currentYear} Radici Soluzioni Informatiche — https://radici.biz
      </footer>
    </div>
  )
}

function Feature({ text }: { text: string }) {
  return (
    <div className="flex items-start gap-2">
      <span className="mt-1 inline-block h-2 w-2 rounded-full bg-indigo-500" aria-hidden="true"></span>
      <span>{text}</span>
    </div>
  )
}